import classNames from 'classnames';
import styles from './SummaryRow.module.css';
import { ReactElement } from 'react';

const SummaryRow = ({
    isLoading,
    children,
    className
}: {
    isLoading?: boolean;
    children: ReactElement[];
    className?: string;
}) => {
    const [label, value] = children;

    return (
        <div
            className={classNames(className, styles.SummaryRow)}
            data-testid="summary-row"
        >
            {label}
            <div
                className={classNames(styles.value, {
                    [styles.loadingValue]: isLoading
                })}
            >
                {value}
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default SummaryRow;
